import React from 'react';
import { createPortal } from 'react-dom';
import { PositionStrategy } from 'react-tooltip';
import { Info } from 'src/assets/dynamicSvg';
import * as S from './Tooltip.styles';

interface TooltipProps {
  dataId?: string;
  dataHtml: string;
  children?: React.ReactNode;
  place?: 'top' | 'bottom' | 'left' | 'right';
  maxWidth?: number;
  positionStrategy?: PositionStrategy;
  noIcon?: boolean;
  delayShow?: number;
  infoIconStyle?: React.CSSProperties;
  inline?: boolean;
}

export const Tooltip: React.FC<TooltipProps> = ({
  dataId = 't-tip',
  dataHtml,
  children,
  place = 'left',
  maxWidth = 440,
  positionStrategy = 'absolute',
  noIcon = false,
  delayShow,
  infoIconStyle,
  inline = false,
}) => {
  return (
    <S.Div>
      {createPortal(
        <S.Div>
          <S.StyledTooltip
            id={dataId}
            place={place}
            positionStrategy={positionStrategy}
            style={{
              zIndex: 9999,
              maxWidth,
              wordBreak: 'break-word',
              overflowWrap: 'break-word',
              wordWrap: 'break-word',
              borderRadius: '6px',
              whiteSpace: 'pre-wrap',
            }}
            delayShow={delayShow}
            opacity={1}
          />
        </S.Div>,
        document.body,
      )}
      {children ? (
        <div
          data-tooltip-id={dataId}
          data-tooltip-html={dataHtml}
          className={inline ? 'tooltip-children tooltip-children-inline' : 'tooltip-children'}
        >
          {children}
        </div>
      ) : (
        <>{noIcon ? null : <Info data-tooltip-id={dataId} data-tooltip-html={dataHtml} style={infoIconStyle} />}</>
      )}
    </S.Div>
  );
};
